import { useTranslation } from 'react-i18next';
import { Accessibility } from 'lucide-react';

import { useComfort } from '@/hooks/useComfort';
import { trackEvent } from '@/utils/analytics';

/**
 * Comfort-mode toggle — augmente la typo, renforce le contraste, désactive les
 * animations. Pensé pour les retraités (pensionado) et plus largement
 * l'accessibilité. Inspiré du mode senior d'Uber.
 *
 * Stateless wrapper autour de useComfort() ; styling miroir de ThemeToggle
 * (pill + icône) pour cohérence header. Mounted dans Header (desktop) et
 * MobileMenu (drawer).
 *
 * @param {object} props
 * @param {string} [props.className]
 */
export default function ComfortToggle({ className = '' }) {
  const { t } = useTranslation('components');
  const { enabled, toggle } = useComfort();

  const label = enabled
    ? t('comfortToggle.disable', { defaultValue: 'Désactiver le mode confort' })
    : t('comfortToggle.enable', { defaultValue: 'Activer le mode confort' });

  return (
    <button
      type="button"
      role="switch"
      aria-checked={enabled}
      aria-label={label}
      title={label}
      onClick={() => { toggle(); trackEvent('comfort_mode_toggle', { enabled: !enabled }); }}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-full border transition-colors ${
        enabled
          ? 'border-bordeaux-600 bg-bordeaux-600 text-cream-50 shadow-sm'
          : 'border-navy-900/15 bg-cream-50 text-navy-900/60 hover:text-navy-900 dark:border-cream-50/15 dark:bg-navy-800 dark:text-cream-50/60 dark:hover:text-cream-50'
      } ${className}`}
    >
      <Accessibility size={15} aria-hidden="true" />
    </button>
  );
}
